export const userRole = {
  KWSM: "KWSM",
  KWA: "KWA",
  KWU: "KWU",
};
